export const NEWSLETTER_EMAIL = 'email';
export const NEWSLETTER_TERMS = 'termsConditions';
